import script from "./CardsSliderView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsSliderView.vue?vue&type=script&setup=true&lang=js"

import "./CardsSliderView.vue?vue&type=style&index=0&id=3b9fd4e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9fd4e4"]])

export default __exports__